import React, { FC } from "react";
import { StyledModal, Title, CloseCircleFilled } from "./elements";
import { theme } from "../../../config";
import { useMediaQuery } from "../../../hooks/common";

export type Props = {
  visible: boolean;
  onModalClose: () => void;
  title: string;
  body: JSX.Element | (() => void);
  height?: string;
  destroyOnClose?: boolean;
  width?: number | string;
  closable?: boolean;
};

const Modal: FC<Props> = (props: any) => {
  const { onModalClose, title, body, width, closable, ...others } = props;
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.mobileAndTablet);

  return (
    <>
      <StyledModal
        {...others}
        footer={null}
        closeIcon={<CloseCircleFilled />}
        width={!isMobileOrTablet ? width || 768 : "auto"}
        centered
        onCancel={onModalClose}
        closable={closable}
      >
        <Title>{title}</Title>
        {body}
      </StyledModal>
    </>
  );
};

export default Modal;
